import React, { useMemo, useState } from "react";
import cloneDeep from 'lodash.clonedeep';
import { useLocaleContext } from "../../context/LocaleContext";
import { usePlayerContext } from "../../context/PlayerContext";
import { CButton } from "../../components/UI";
import './style.scss';

const numberPartnersDisplayed = 27;

export default ({ block }) => {
    const { get: getLocale, getProperty } = useLocaleContext();
    const { tabletView } = usePlayerContext();
    const [isShowMore, setIsShowMore] = useState(false);

    const className = "partners-block";
    const partners = block?.blockPartners || [];
    const isViewButtonShowMore = partners.length > numberPartnersDisplayed && !isShowMore && tabletView;

    const viewPartners = useMemo(() => {
        let _partners = cloneDeep(partners || []);
        _partners = _partners.sort((a, b) => a.order - b.order);

        if (isViewButtonShowMore) {
            _partners = partners.slice(0, numberPartnersDisplayed);
        }

        return _partners;
    }, [partners, isViewButtonShowMore]);

    const handleNavigateTo = (navigateTo) => {
        if (!navigateTo) {
            return;
        }

        window.open(navigateTo);
    }

    const style = {
        backgroundImage: `url(${block.imageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    }

    return (
        <section className={`page-block ${className}`} style={style}>
            <h1>{getProperty(block, 'title')}</h1>
            {block.showSubtitle && <p>{getProperty(block, 'subtitle')}</p>}

            <div className={`${className}-wrapper`}>
                {viewPartners?.map((partner) => (
                    <div
                        key={partner.id}
                        className={`${className}-partner ${partner.partnerSiteUrl ? '-can-press' : ''}`}
                        style={{backgroundColor: `#${partner.backgroundColor}`}}
                        onClick={() => handleNavigateTo(partner.partnerSiteUrl)}
                    >
                        {partner.logoImageUrl && (
                            <img
                                src={partner.logoImageUrl}
                                alt={getProperty(partner, 'name') || 'partner'}
                                title={getProperty(partner, 'name')}
                            />
                        )}
                    </div>
                ))}
            </div>

            {isViewButtonShowMore && (
                <CButton
                    className={`${className}-show-more-button`}
                    label={getLocale('label.show-more')}
                    onClick={() => setIsShowMore(true)}
                />
            )}
        </section>
    );
};